import { Component, HostListener } from '@angular/core';


import { FormControl, Validators } from '@angular/forms';
import { ShHtmlParserComponent } from '../../../core/html-parser/html-parser.component';
import { ShIconComponent } from '../../../elements/components/icon/icon.component';
import { ShFormTextInputComponent } from '../../../form-controls/components/form-text/main/form-text.component';
import { DialogConfig } from '../../entities/dialog-config.entity';
import { DialogRef } from '../../entities/dialog-ref.class';

@Component({
    selector: 'sh-text-input-dialog-component',
    templateUrl: './text-input-dialog.component.html',
    standalone: true,
    imports: [ShIconComponent, ShHtmlParserComponent, ShFormTextInputComponent]
})
export class ShTextInputDialogComponent {
    inputControl = new FormControl('', { validators: Validators.required });

    constructor(
        public config: DialogConfig,
        public dialog: DialogRef<string | null>
    ) {}

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        if (!this.inputControl.invalid) {
            return;
        }
        this.confirm();
    }

    confirm(): void {
        this.dialog.close(this.inputControl.value);
    }

    no(): void {
        this.dialog.close(null);
    }
}
